module.exports = __webpack_public_path__ + "static/media/1-how-to.dfb37129.png";